import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Badge } from "@similarweb/ui-components";
import { Box, Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

import { responsiveThreeColumnGrid } from "../constants";
import type { ITopMovers } from "../websiteRankings.types";

import { MoversCard } from "./MoversCard";

const CardsGrid = styled(Box)`
    ${responsiveThreeColumnGrid}
    gap: 24px;
`;

interface ITopMoversStripProps {
    movers: ITopMovers;
    isLoading?: boolean;
    isError?: boolean;
}

export const TopMoversStrip = ({ movers, isLoading = false, isError = false }: ITopMoversStripProps) => {
    const { climbers, fallers, newEntrants } = movers;

    return (
        <Stack
            gap="16px"
            data-automation="website-rankings-top-movers"
        >
            <Flex
                alignItems="center"
                gap="8px"
            >
                <Text
                    fontVariant="h5"
                    color={colorsPalettes.carbon["500"]}
                >
                    {translate("website.rankings.top.movers.title", {}, "Top movers this period")}
                </Text>
                <Badge
                    type="custom"
                    bgColor={colorsPalettes.orange["400"]}
                    color={colorsPalettes.carbon["0"]}
                    shouldTransformTextToUpperCase
                >
                    {translate("website.rankings.new.entrant.badge")}
                </Badge>
            </Flex>
            <CardsGrid>
                <MoversCard
                    variant="climbers"
                    movers={climbers}
                    isLoading={isLoading}
                    isError={isError}
                />
                <MoversCard
                    variant="fallers"
                    movers={fallers}
                    isLoading={isLoading}
                    isError={isError}
                />
                <MoversCard
                    variant="newEntrants"
                    movers={newEntrants}
                    isLoading={isLoading}
                    isError={isError}
                />
            </CardsGrid>
        </Stack>
    );
};

TopMoversStrip.displayName = "TopMoversStrip";
